// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem-module__menuItem___gDlY4","softDisabled":"MenuItem-module__softDisabled___au3BZ"};